import env from '../../store/base/config/env'
import { phone, character, medicare } from '../helpers/regex_helpers'

const passwordStrength = env.VUE_APP_PASSWORD_STRENGTH
const abnWeightFactor = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19]

const rules = {
    password: {
        getMessage: (field, params, data) => data.message,
        validate: (value) => {
            var message = validate_password(value)
            var valid = message === true
            return {
                valid,
                data: message === true ? undefined : { message }
            }
        }
    },
    min_count: {
        getMessage: (field, { min }, data) => `${field} needs at least ${min} entries.`,
        validate: (value, { min }) => {
            return value.length >= min
        }
    },
    phone: {
        getMessage: (field, params, data) => `Invalid phone number`,
        validate: (value, params) => {
            return phone.AUS_REGEX.test(value)
        }
    },
    medicare: {
        getMessage: (field, params, data) => `Invalid medicare number`,
        validate: (value, params) => {
            return medicare.MEDICARE_REGEX.test(value)
        }
    },
    abn: {
        getMessage: (field, params, data) => data.message,
        validate: (value) => {
            var message = validateAbn(value)

            var valid = message === true
            return {
                valid,
                data: message === true ? undefined : { message }
            }
        }
    }
}
function validate_password(password) {
    // validate length 8 - 20 chars
    if (passwordStrength > 0) {
        if (password.length < 8) {
            return 'Needs at least 8 characters'
        }
        if (password.length >= 20) {
            return 'Needs at most 20 characters'
        }
    }

    // requires number + alpha
    if (passwordStrength > 1) {
        if (!character.ALPHA_REGEX.test(password)) {
            return 'Requires a letter'
        }
        if (!character.NUMERIC_REGEX.test(password)) {
            return 'Requires a number'
        }
    }

    // requires lower + upper
    if (passwordStrength > 2) {
        if (!character.LOWERCASE_REGEX.test(password)) {
            return 'Requires a lowercase'
        }
        if (!character.UPPERCASE_REGEX.test(password)) {
            return 'Requires an uppercase'
        }
    }

    // requires special
    if (passwordStrength > 3) {
        if (!character.SPECIAL_CHAR_REGEX.test(password)) {
            return 'Requires a special character'
        }
    }

    return true
}
function validateAbn(rawAbn) {
    var trimmedAbn = rawAbn.replace(/\s+/g, '')
    if (trimmedAbn.length < 11) {
        return 'Requires 11 digit'
    }
    if (character.ALPHA_REGEX.test(trimmedAbn)) {
        return 'Only numbers is allowed'
    }

    if (trimmedAbn.length == 11 && !character.ALPHA_REGEX.test(trimmedAbn)) {
        var initialNum = trimmedAbn.substring(0, 1)
        initialNum--
        var newtrimmedAbn = `${initialNum}${trimmedAbn.substring(1, 11)}`.toString()
        var arrAbn = newtrimmedAbn.split('')

        var i = 0
        var sum = 0
        arrAbn.forEach((num) => {
            sum += parseInt(num) * abnWeightFactor[i++]
        })
        if (sum % 89 != 0) {
            return 'Invalid ABN'
        }
    }
    if (trimmedAbn.length > 11) {
        return 'Max of 11 digit only'
    }
    return true
}
export default rules
